/**
 * 网页端微信扫码登录（开放平台「网站应用」+ 授权回调 URL）。
 * 已配置公网域名后，建议开启并配合后端 WECHAT_WEB_* 环境变量使用。
 */
export const ENABLE_WECHAT_WEB_LOGIN = true;
